import { jsx as l } from "react/jsx-runtime";
const r = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.5 12.598 13 13V5.896L8 3.204 3 5.896V13h10l.402 1.5H1.5V5L8 1.5 14.5 5v7.598Zm-9.034-.589-1.06-1.06 1.239-1.24-1.866-1.867 2.3-2.3 1.06 1.061-1.24 1.24 1.867 1.866-2.3 2.3Zm4.201 0-1.061-1.06 1.24-1.24-1.867-1.867 2.3-2.3 1.06 1.061-1.239 1.24 1.867 1.866-2.3 2.3Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  r as WarmHome
};
